import { QueryResult, QueryConfig } from "@/shared/types/base";
import { sleep } from "@/shared/utils";
import { api } from "@/api";
import { useQuery } from "@tanstack/react-query";
import { ReactNode } from "react";
import { Pais } from "@/shared/types/pais";

export async function getPais(id: string): Promise<Pais> {
    await sleep(1000);
    const response = await api.get("paises/" + id);
    return response.data;
}

export function useGetPaisQuery(id: string, queryConfig: QueryConfig<Pais> = {}) {
    return useQuery({
        ...queryConfig,
        queryFn: async () => await getPais(id),
        queryKey: ["paises", id],
    })
}

export interface GetPaisQueryProps {
    id: string,
    queryConfig?: QueryConfig<Pais>,
    children?: (queryResult: QueryResult<Pais>) => ReactNode
}

export function GetPaisQuery({
    id,
    children,
    queryConfig
}: GetPaisQueryProps) {
    const queryResult = useGetPaisQuery(id, queryConfig);
    return children && children(queryResult);
}